import { render } from "./DeveloperTab.vue?vue&type=template&id=2e4c489c&scoped=true"
import script from "./DeveloperTab.vue?vue&type=script&lang=js"
export * from "./DeveloperTab.vue?vue&type=script&lang=js"

import "./DeveloperTab.vue?vue&type=style&index=0&id=2e4c489c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4c489c"]])

export default __exports__